import React, { useState, useEffect } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Cookie, X, Settings } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const CookieBanner = () => {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      // Show banner after a short delay
      const timer = setTimeout(() => setIsVisible(true), 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    localStorage.setItem('cookiePreferences', JSON.stringify({
      necessary: true,
      analytics: true,
      marketing: false
    }));
    setIsVisible(false);
  };

  const acceptNecessary = () => {
    localStorage.setItem('cookieConsent', 'necessary');
    localStorage.setItem('cookiePreferences', JSON.stringify({
      necessary: true,
      analytics: false,
      marketing: false
    }));
    setIsVisible(false);
  };

  const closeBanner = () => {
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 max-w-md mx-auto md:max-w-lg md:left-auto md:right-4 md:mx-0">
      <Card className="bg-white/95 backdrop-blur-sm border-emerald-200 shadow-xl">
        <CardContent className="p-4">
          <div className="flex items-start gap-3">
            <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
              <Cookie className="w-4 h-4 text-emerald-600" />
            </div>
            
            <div className="flex-1">
              <h3 className="font-semibold text-gray-900 text-sm mb-2">
                🍪 Cookies & Datenschutz
              </h3>
              
              {!showDetails ? (
                <div>
                  <p className="text-gray-700 text-sm mb-4">
                    Wir verwenden nur technisch notwendige Cookies für die Anmeldung. 
                    YouTube-Videos werden datenschutzfreundlich über youtube-nocookie.com eingebunden.
                    Keine Tracking- oder Werbe-Cookies.
                  </p>
                  
                  <div className="flex flex-wrap gap-2">
                    <Button
                      onClick={acceptAll}
                      size="sm"
                      className="bg-emerald-600 hover:bg-emerald-700 text-white text-xs px-3 py-1"
                    >
                      Verstanden
                    </Button>
                    <Button
                      onClick={() => setShowDetails(true)}
                      variant="outline"
                      size="sm"
                      className="text-xs px-3 py-1 border-gray-300"
                    >
                      <Settings className="w-3 h-3 mr-1" />
                      Details
                    </Button>
                  </div>
                </div>
              ) : (
                <div>
                  <div className="space-y-3 mb-4">
                    <div className="flex items-center justify-between">
                      <span className="text-sm text-gray-700">Notwendige Cookies</span>
                      <span className="text-xs bg-gray-100 px-2 py-1 rounded text-gray-600">
                        Erforderlich
                      </span>
                    </div>
                    <p className="text-xs text-gray-600">
                      Für Anmeldung und grundlegende Funktionen der App. YouTube-Videos werden 
                      datenschutzfreundlich über youtube-nocookie.com eingebunden.
                    </p>
                  </div>
                  
                  <div className="flex flex-wrap gap-2">
                    <Button
                      onClick={acceptAll}
                      size="sm"
                      className="bg-emerald-600 hover:bg-emerald-700 text-white text-xs px-3 py-1"
                    >
                      Alle akzeptieren
                    </Button>
                    <Button
                      onClick={acceptNecessary}
                      variant="outline"
                      size="sm"
                      className="text-xs px-3 py-1 border-gray-300"
                    >
                      Nur notwendige
                    </Button>
                    <Button
                      onClick={() => setShowDetails(false)}
                      variant="ghost"
                      size="sm"
                      className="text-xs px-2 py-1"
                    >
                      Zurück
                    </Button>
                  </div>
                </div>
              )}
            </div>
            
            <button
              onClick={closeBanner}
              className="text-gray-400 hover:text-gray-600 transition-colors flex-shrink-0"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
          
          <div className="mt-3 pt-3 border-t border-gray-200">
            <p className="text-xs text-gray-500">
              Mehr Infos in unserer{' '}
              <button 
                onClick={() => navigate('/privacy')}
                className="text-emerald-600 hover:underline"
              >
                Datenschutzerklärung
              </button>
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}; 